import React, { useEffect, useRef } from "react";
import jsonData from "../JSON Data/resources.json";
import { Link, useParams } from "react-router-dom";

function Resources() {
  const { section } = useParams();
  const sectionData = jsonData[section];
  const observedElements = useRef([]);
  const processContent = (content) => {
    const colonIndex = content.indexOf(":");
    if (colonIndex !== -1) {
      const beforeColon = content.substring(0, colonIndex + 1).trim();
      const afterColon = content.substring(colonIndex + 1).trim();
      const wordsCount = beforeColon.split(" ").length;

      if (wordsCount <= 10) {
        return (
          <>
            <strong>{beforeColon}</strong> {afterColon}
          </>
        );
      }
    }
    return content;
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.transform = "scale(1)";
            entry.target.style.opacity = "1";
          } else {
            entry.target.style.transform = "scale(0.95)";
            entry.target.style.opacity = "0";
          }
        });
      },
      { threshold: 0.1 }
    );

    observedElements.current.forEach((el) => {
      observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  if (!sectionData || !sectionData.contents) {
    return <div>Data not found or invalid format</div>;
  }

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

  return (
    <>
      <div className="template">
        <div className="templatebrd resourcebg">
          <h2>{sectionData.breadCrumb}</h2>
          <h1>
            {sectionData.breadCrumb ===
            "RESOURCES AND TOOLKITS / BLOG / ARTICLES / VIDEOS"
              ? "BLOG / ARTICLES / VIDEOS"
              : sectionData.breadCrumb
                  .split("/")
                  .map((item) => item.trim())
                  .pop()}
          </h1>
        </div>
        <div className="templatecontent">
          {sectionData.contents.map((element, index) => (
            <React.Fragment key={index}>
              {element.tag === "img" ? (
                <img
                  src={process.env.PUBLIC_URL + element.src}
                  alt={element.alt || ""}
                  ref={(el) => {
                    if (el) {
                      observedElements.current.push(el);
                    }
                  }}
                  style={{ transition: "all 500ms ease" }}
                />
              ) : element.tag === "ul" ? (
                <ul>
                  {element["list-items"].map((item, i) => (
                    <li key={i}>{processContent(item)}</li>
                  ))}
                </ul>
              ) : element.tag === "ol" ? (
                <ol>
                  {element["list-items"].map((item, i) => (
                    <li key={i}>{processContent(item)}</li>
                  ))}
                </ol>
              ) : (
                React.createElement(
                  element.tag,
                  {
                    key: index,
                    ref: (el) => {
                      if (el) {
                        observedElements.current.push(el);
                      }
                    },
                    style: { transition: "all 500ms ease" },
                  },

                  processContent(element.content)
                )
              )}
            </React.Fragment>
          ))}

          {sectionData.breadCrumb ===
          "RESOURCES AND TOOLKITS / BRAND PROTECTION TOOLKITS" ? (
            <div className="text-center">
              <Link
                style={{
                  border: "none",
                  margin: "10px",
                  backgroundColor: "#e11d48",
                }}
                className="btn btn-primary mb-3"
                to={"/spansuit/brandprotection/form1"}
              >
                Brand Protection Risk Assessment
              </Link>
              <Link
                style={{
                  border: "none",
                  backgroundColor: "#e11d48",
                }}
                className="btn btn-primary mb-3"
                to={"/spansuit/brandprotection/form2"}
              >
                Product Risk Assessment
              </Link>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
}

export default Resources;
